import chroma from 'chroma-js'

/**
 * Generates a hex color from a range [0, 1] based on the given min and max colors.
 *
 * @param min - The starting (minimum) color as a hex string (e.g. #ff0000).
 * @param max - The ending (maximum) color as a hex string (e.g. #00ff00).
 * @param value - A number in the range [0, 1] determining the position between min and max.
 * @returns A hex color string representing the interpolated color.
 */
export function interpolateHexColor(min: string, max: string, value: number): string {
  const colorParser = chroma.scale([min, max]).mode('lab')
  return colorParser(value).hex()
}
